import React from "react";

const Header2 = () => {
  return (
    <header
      className="header_sticky"
      style={{
        position: "fixed",
        top: "56px",
        left: 0,
        width: "100%",
        zIndex: 1040,
        backgroundColor: "#ffffff",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-6"></div>
          <nav className="col-lg-9 col-6">
            <a
              className="cmn-toggle-switch cmn-toggle-switch__htx open_close"
              href="#0"
            >
              <span>Menu mobile</span>
            </a>
            <div className="main-menu">
              <ul style={{ display: "flex", flexWrap: "nowrap", margin: 0, padding: "0 5px" }}>
                <li className="submenu" style={{ flex: "0 0 auto", margin: "0 4px" }}>
                  <a href="#0" className="show-submenu">
                    Proctology<i className="icon-down-open-mini"></i>
                  </a>
                  <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <li><a href="/Piles">Piles Treatment</a></li>
                    <li><a href="/Fistula">Fistula Treatment</a></li>
                    <li><a href="/Fissure">Fissure Treatment</a></li>
                    <li><a href="/Pilonidal">Pilonidal Sinus Treatment</a></li>
                    <li><a href="/Rectal">Rectal Prolapse</a></li>
                  </ul>
                </li>
                <li className="submenu" style={{ flex: "0 0 auto", margin: "0 4px" }}>
                  <a href="#0" className="show-submenu">
                    Laparoscopy<i className="icon-down-open-mini"></i>
                  </a>
                  <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <li><a href="/Hernia">Hernia Surgery</a></li>
                    <li><a href="/Gallstones">Gallstones Treatment</a></li>
                    <li><a href="/Appendicitis">Appendicitis</a></li>
                    <li><a href="/Inguinal">Inguinal Hernia Treatment</a></li>
                    <li><a href="/Umbilical">Umbilical Hernia Treatment</a></li>
                  </ul>
                </li>
                <li className="submenu" style={{ flex: "0 0 auto", margin: "0 4px" }}>
                  <a href="#0" className="show-submenu">
                    Gynaecology<i className="icon-down-open-mini"></i>
                  </a>
                  <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <li><a href="/Surgical">Surgical Abortion</a></li>
                    <li><a href="/MTP">MTP</a></li>
                    <li><a href="/Ectopic">Ectopic Pregnancy Treatment</a></li>
                    <li><a href="/Molar">Molar Pregnancy Treatment</a></li>
                    <li><a href="/Uterus">Uterus Removal</a></li>
                    <li><a href="/Ovarian">Ovarian Cyst</a></li>
                    <li><a href="/Miscarriage">Miscarriage Treatment</a></li>
                    <li><a href="/Bartholin">Bartholin Cyst Treatment</a></li>
                    <li><a href="/Endometriosis">Endometriosis Treatment</a></li>
                    <li><a href="/Adenomyosis">Adenomyosis Treatment</a></li>
                    <li><a href="/PCOS-PCOD">PCOS-PCOD Treatment</a></li>
                    <li><a href="/Pregnancy">Pregnancy Care</a></li>
                    <li><a href="/Laser">Laser Vaginal Tightening</a></li>
                    <li><a href="/Hymenoplasty">Hymenoplasty</a></li>
                    <li><a href="/Vaginoplasty">Vaginoplasty</a></li>
                    <li><a href="/Labiaplasty">Labiaplasty</a></li>
                    <li><a href="/Vaginal">Vaginal Wart Removal</a></li>
                  </ul>
                </li>
                <li className="submenu" style={{ flex: "0 0 auto", margin: "0 4px" }}>
                  <a href="#0" className="show-submenu">
                    Vascular<i className="icon-down-open-mini"></i>
                  </a>
                  <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <li><a href="/Varicose">Varicose Veins Treatment</a></li>
                    <li><a href="/Varicocele">Varicocele Treatment</a></li>
                    <li><a href="/DVT">DVT Treatment</a></li>
                    <li><a href="/Diabetic">Diabetic Foot Ulcer Treatment</a></li>
                    <li><a href="/Uterine">Uterine Fibroids</a></li>
                    <li><a href="/AVFistula">AV Fistula</a></li>
                  </ul>
                </li>
                <li className="submenu" style={{ flex: "0 0 auto", margin: "0 4px" }}>
                  <a href="#0" className="show-submenu">
                    Aesthetics<i className="icon-down-open-mini"></i>
                  </a>
                  <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <li><a href="/Gynecomastia">Gynecomastia</a></li>
                    <li><a href="/Liposuction">Liposuction</a></li>
                    <li><a href="/Lipoma">Lipoma Surgery</a></li>
                    <li><a href="/Breast">Breast Lift Surgery</a></li>
                    <li><a href="/Sebaceous">Sebaceous Cyst Surgery</a></li>
                    <li><a href="/Rhinoplasty">Rhinoplasty</a></li>
                    <li><a href="/BreastAugmentation">Breast Augmentation Surgery</a></li>
                    <li><a href="/Axillary">Axillary Breast</a></li>
                    <li><a href="/TummyTuck">Tummy Tuck</a></li>
                    <li><a href="/BreastLump">Breast Lump</a></li>
                    <li><a href="/BreastReduction">Breast Reduction</a></li>
                    <li><a href="/ScarRemoval">Scar Removal</a></li>
                    <li><a href="/DoubleChin">Double Chin</a></li>
                    <li><a href="/BuccalFat">Buccal Fat</a></li>
                    <li><a href="/EarlobeRepair">Earlobe Repair</a></li>
                    <li><a href="/Blepharoplasty">Blepharoplasty</a></li>
                    <li><a href="/BeardTransplant">Beard Transplant</a></li>
                    <li><a href="/CleftLip">Cleft Lip</a></li>
                    <li><a href="/HairFallPRP">Hair Fall PRP</a></li>
                  </ul>
                </li>
                <li className="submenu" style={{ flex: "0 0 auto", margin: "0 4px" }}>
                  <a href="#0" className="show-submenu">
                    Orthopedics<i className="icon-down-open-mini"></i>
                  </a>
                  <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <li><a href="/KneeReplacement">Knee Replacement</a></li>
                    <li><a href="/CarpalTunnelSyndrome">Carpal Tunnel Syndrome</a></li>
                    <li><a href="/ACLTearTreatment">ACL Tear Treatment</a></li>
                    <li><a href="/MeniscusTearTreatment">Meniscus Tear Treatment</a></li>
                    <li><a href="/HipReplacementSurgery">Hip Replacement Surgery</a></li>
                    <li><a href="/SpineSurgery">Spine Surgery</a></li>
                    <li><a href="/ShoulderDislocation">Shoulder Dislocation</a></li>
                    <li><a href="/ShoulderReplacement">Shoulder Replacement</a></li>
                    <li><a href="/index-2">Rotator Cuff Repair</a></li>
                    <li><a href="/">Arthroscopy Surgery</a></li>
                    <li><a href="/">Knee Arthroscopy</a></li>
                    <li><a href="/index-2">Shoulder Arthroscopy</a></li>
                    <li><a href="/">Total Knee Replacement</a></li>
                  </ul>
                </li>
                <li className="submenu" style={{ flex: "0 0 auto", margin: "0 4px" }}>
                  <a href="#0" className="show-submenu">
                    Fertility<i className="icon-down-open-mini"></i>
                  </a>
                  <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <li><a href="/">IVF</a></li>
                    <li><a href="/index-2">IUI</a></li>
                    <li><a href="/">Female Infertility</a></li>
                    <li><a href="/index-2">Male Infertility</a></li>
                    <li><a href="/">Embryo Transfer</a></li>
                    <li><a href="/">Egg Freezing</a></li>
                  </ul>
                </li>
                <li className="submenu" style={{ flex: "0 0 auto", margin: "0 4px" }}>
                  <a href="#0" className="show-submenu">
                    Weight Loss<i className="icon-down-open-mini"></i>
                  </a>
                  <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <li><a href="/">Bariatric Surgery</a></li>
                    <li><a href="/index-2">SPATZ intragastric balloon</a></li>
                    <li><a href="/">Weightloss Surgery</a></li>
                  </ul>
                </li>
                <li className="submenu" style={{ flex: "0 0 auto", margin: "0 4px" }}>
                  <a href="#0" className="show-submenu">
                    Dermatology<i className="icon-down-open-mini"></i>
                  </a>
                  <ul style={{ maxHeight: "300px", overflowY: "auto" }}>
                    <li><a href="/">Fat Loss</a></li>
                    <li><a href="/index-2">Botox</a></li>
                    <li><a href="/">Dermal Fillers</a></li>
                    <li><a href="/index-2">Hair Transplant</a></li>
                    <li><a href="/">Anti-Aging</a></li>
                    <li><a href="/">Pigmentation</a></li>
                    <li><a href="/">Hydra Facial</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header2;